import * as React from 'react';
import ToggleSwitch from '../../../../Form/ToggleSwitch';
import { T } from '../../../../../Translations';

interface Props {
  isPublished: boolean;
  onTogglePublished: () => void;
  isPublishing: boolean;
}

const ParticipantAccessToggle: React.FC<Props> = ({
  isPublished,
  onTogglePublished,
  isPublishing,
}) => {
  return (
    <div className="flex items-center gap-3 mb-8">
      <ToggleSwitch
        checked={isPublished}
        onChange={onTogglePublished}
        disabled={isPublishing}
        ariaLabel="Allow Participant Access"
        dataAttributes={{
          'data-intercom-target': `participant-access-toggle-${isPublished ? 'on' : 'off'}`,
        }}
      />
      <span className="font-semibold text-sm leading-5 tracking-normal text-gray-900">
        <T kind="Allow Participant Access" />
      </span>
    </div>
  );
};

export default ParticipantAccessToggle;
